var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4613 16.8803L15.3852 13.8042C17.9625 10.5618 17.4637 5.823 14.2213 3.24573C10.9789 0.668472 6.24011 1.25043 3.66285 4.40966C1.08559 7.65202 1.66755 12.3909 4.82677 14.9681C7.57031 17.1297 11.4778 17.1297 14.2213 14.9681L17.2974 18.0442C17.6299 18.3768 18.1288 18.3768 18.4613 18.0442C18.7939 17.7117 18.7939 17.2128 18.4613 16.8803ZM9.56561 14.9681C6.32325 14.9681 3.74599 12.3909 3.74599 9.1485C3.74599 5.90613 6.32325 3.32887 9.56561 3.32887C12.808 3.32887 15.3852 5.90613 15.3852 9.1485C15.3852 12.3909 12.808 14.9681 9.56561 14.9681Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.505b04453df8463acc94791295624272.svg";
export { ForwardRef as ReactComponent };